import { Button, ButtonGroup, closeCurrentDialog, Form, FormButton, FormField, useTranslationContext } from 'platform/components';
import { VStack } from 'platform/foundation-tw';
import { z } from 'zod';
import { RequiredTestIdProps, suffixTestId } from 'shared/web';
import { SharePresetToUseRequestBody } from '../../../../types/Api';
import { UserOptionsQuery } from '../../../../types/UserOptionsQuery';
import { useSharePresetToUser } from '../../hooks/useSharePresetToUser';
type SharePresetForUserDialogProps = RequiredTestIdProps & {
  presetId: string;
  gridCode: string;
  useGetUserOptionsQuery: () => UserOptionsQuery;
};
const schema = z.object({
  userIds: z.array(z.string()).min(1)
});
export function SharePresetForUserDialog(props: SharePresetForUserDialogProps) {
  // TODO [T20-????]: useGetUserOptionsQuery is a hook function passed as a prop —
  // an architectural pattern that violates React's rule of stable hook identity.
  // Fix: hoist the hook call to the parent and pass the result (data, isLoading) as props instead.
  const {
    userOptions,
    isLoading
  } = props.useGetUserOptionsQuery();
  const t = useTranslationContext();
  const {
    onSubmit
  } = useSharePresetToUser(props.presetId, props.gridCode);
  return <Form<SharePresetToUseRequestBody> onSubmit={onSubmit} experimentalZodSchema={schema}>
      {control => <VStack spacing={4}>
          <FormField data-testid={suffixTestId('userIds', props)} control={control} type="multiChoice" name="userIds" options={userOptions ?? []} placeholder={t('general.presets.userShare')} isLoading={isLoading} />
          <ButtonGroup align="right">
            <Button data-testid={suffixTestId('discardButton', props)} variant="secondary" title={t('general.actions.discard')} onClick={closeCurrentDialog} />
            <FormButton data-testid={suffixTestId('submitButton', props)} control={control} type="submit" title={t('general.actions.share')} />
          </ButtonGroup>
        </VStack>}
    </Form>;
}